// This is a hack to make leaflet map react on actions.
// Normally You should keep it's center and zoom in store for example,
// update them with actions and redraw map in react component, but leaflet
// map is stateful and it is complicated to implement. (maybe later)
// DON'T USE IN REACT COMPONENTS AND OUTSIDE OF LAYER RENDERERS
export default function lastDispatchedAction(
  state: IAction<any>,
  action: IAction<any>,
): IAction<any> {
  return action;
}
